import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  TextField
} from "@material-ui/core";

import { addComment } from "../../actions/processActions";
import { closeCommentModal } from "../../actions/modalActions";

class CommentModal extends Component {
  state = { formData: { comment: "", name: "" } };

  handleClose = () => {
    if (new Date() - this.props.modalOpenTime > 1000) {
      this.props.closeCommentModal();
    }
  };

  handleSubmit = () => {
    this.props.addComment(this.state.formData);
    this.handleClose();
  };

  handleChangeFormData = (key, value) => {
    this.setState({ formData: { ...this.state.formData, [key]: value } });
  };

  render() {
    const actions = [
      <Button color="secondary" onClick={this.handleClose}>
        Close
      </Button>,
      <Button color="primary" onClick={this.handleSubmit}>
        Submit
      </Button>
    ];

    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Submit a comment</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Your name"
            value={this.state.formData.name}
            onChange={event =>
              this.handleChangeFormData("name", event.target.value)
            }
          />
          <br />
          <TextField
            margin="dense"
            label="Comment"
            multiline
            fullWidth
            value={this.state.formData.comment}
            onChange={event =>
              this.handleChangeFormData("comment", event.target.value)
            }
          />
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    isOpen: state.modal.commentModalIsOpen,
    modalOpenTime: state.modal.modalOpenTime
  };
}

export default connect(
  mapStateToProps,
  { addComment, closeCommentModal }
)(CommentModal);
